import { createContext, forwardRef, useContext } from "react";
import { Link, LinkProps } from "react-router";

type HeaderNavigationContextValue = {
  clientRouterLinks: boolean
}

const HeaderNavigationContext = createContext<HeaderNavigationContextValue>({
  clientRouterLinks: false,
});

export const HeaderNavigationProvider = HeaderNavigationContext.Provider;

const HeaderLink = forwardRef<HTMLAnchorElement, LinkProps>(function HeaderLink(props, ref) {
  const { clientRouterLinks } = useContext(HeaderNavigationContext);
  const { reloadDocument, ...linkProps } = props;

  return <Link
    {...linkProps}
    ref={ref}
    reloadDocument={reloadDocument ?? !clientRouterLinks}
  />
});

export default HeaderLink;
